import BossModel from "@/models/BossModel";
import PlatinumPage from "@/models/PlatinumPage/PlatinumPage.js";

export default class PlatinumOfferRequest extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'platinum-offer-request';

    /**
     *
     * @type {string}
     */
    static entity = 'platinumOfferRequests';

    static fields() {
        return {
            id: this.attr(null),
            platinum_page_id: this.attr(null).nullable(),
            gender_cid: this.attr(null),
            country_ids: this.attr(null).nullable(),
            firstname: this.attr(null),
            lastname: this.attr(null),
            phone_number: this.attr(null),
            email: this.attr(null),
            comments: this.attr(null).nullable(),
            call_back_date: this.attr(null),
            call_back_time: this.attr(null).nullable(),
            country_labels: this.attr(null),
            created_at: this.attr(null),
            platinumPage: this.belongsTo(PlatinumPage, 'platinum_page_id'),
        }
    }
}
